export const SANTA_GRAY_500 = '#9aa4ba';
export const SLATE_700 = '#344054';
export const GRAY_200 = '#E5E7EB';
export const GRAY_500 = '#6B7280';
export const AMBER_500 = '#F59E0B';
export const BLUE_500 = '#3B82F6';
export const GREEN_600 = '#16A34A';
export const PINK_700 = '#C11574';
export const INDIGO_500 = '#6F6AF8';